/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const ArrayClaimValue: core.serialization.ObjectSchema<
    serializers.ArrayClaimValue.Raw,
    Truvity.ArrayClaimValue
> = core.serialization.object({
    value: core.serialization.list(core.serialization.lazy(() => serializers.CredentialClaimValue)),
});

export declare namespace ArrayClaimValue {
    export interface Raw {
        value: serializers.CredentialClaimValue.Raw[];
    }
}
